import { PageBlockTypes as p } from '@xprog/prensa/types'

export const TemplateSideBox: p.PageBlockProps = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      },
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0',
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2',
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0',
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0',
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5',
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top'],
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      },
    },
  }
}